import { scrollOnLoad, scrollToTabs } from '../../custom/photo-gallery-scroll';
import { toggleClass, slideToggle } from '../../custom/common';
const { feWp } = window;
const { addAction } = feWp.hooks;

addAction(
  'b3rg_tab_slider_content_init',
  'b3rg/tab-slider',
  ( settings, swiperTabContent, contentSwiper ) => {
    // scroll to tab section with clicked tab active
    const targetElementSelector = '.e-stn--photo-gallary .e-tbs--slider-tabs';
    const target = document.querySelector( targetElementSelector );
    if( target && contentSwiper.el.closest( targetElementSelector ) ) {
      document.querySelectorAll( 'header .mega-pool-tabs' ).forEach( ( anchor, index ) => {
        anchor.addEventListener( 'click', () => {
          contentSwiper.slideTo( index );
          scrollToTabs();
        } );
      } );
      setTimeout( () => {
        scrollOnLoad();
      }, 500 );
    }

    // microsite content tab structure change
    const microTabs = '.single-microsite .e-stn--content-tab-section .e-tbs';
    const microabsTarget = document.querySelector( microTabs );
    const wW = window.innerWidth;
    const wrapContent = ( container ) => {
      const h2 = container?.querySelector( 'h2' );
      if ( !h2 ) return; // Exit if no h2 is found
      const wrapper = document.createElement( 'div' );
      wrapper.classList.add( 'wrapped-content' );
      let sibling = h2.nextSibling;
      while ( sibling ) {
        let nextSibling = sibling.nextSibling; 
        wrapper.appendChild( sibling );
        sibling = nextSibling;
      }
  
      container.appendChild( wrapper );
    };
    if( microabsTarget && contentSwiper.el.closest( microTabs ) && wW < 768 ) {
      const contentSlides = contentSwiper.el.querySelectorAll( '.swiper-slide' );
      contentSlides.forEach( ( slide ) => {
        const slideRows = slide.querySelectorAll( '.e-row' );
        slideRows.forEach( ( row, index ) => {
          const rowMedia = row.querySelector( '.e-img' );
          const rowHeading = row.querySelector( 'h2.wp-block-heading' );
          const headingParent = rowHeading?.parentNode;
          headingParent?.classList.add( 'tab-accordion-item' );
          headingParent?.insertBefore( rowMedia, rowHeading.nextSibling );
          wrapContent( headingParent );
          const wrappedContent = rowHeading?.nextSibling;
          rowHeading?.addEventListener( 'click', () => {
            slideToggle( wrappedContent, 500 );
            toggleClass( headingParent, 'expanded' );
          } );
          if( index == 0 ) {rowHeading?.click();}
        } );
      } );
    }
  },
  10,
  1,
);
